import React from "react";
import { Paper, Typography, Divider } from "@mui/material";
import TextPanel from "./panels/TextPanel";
import ShapePanel from "./panels/ShapePanel";
import ImagePanel from "./panels/ImagePanel";
import CanvasPanel from "./panels/CanvasPanel";
import PublicationPanel from "./panels/PublicationPanel";

export default function EditorPropertiesPanel({
    mode,
    selectedEl,
    updateEl,
    fileInputRef,
    onFileChange,
    isUploadingMedia,
    canvasBg,
    setCanvasBg,
    canvasSize,
    duration,
    setDuration,
    publishTo,
    setPublishTo,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}) {
    return (
        <Paper
            elevation={3}
            square
            sx={{ width: 270, overflow: "auto", p: 2, flexShrink: 0 }}
        >
            <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                Propriétés
            </Typography>
            <Divider sx={{ mb: 1.5 }} />

            {!selectedEl && (
                <CanvasPanel
                    canvasBg={canvasBg}
                    setCanvasBg={setCanvasBg}
                    canvasSize={canvasSize}
                />
            )}

            {selectedEl?.type === "text" && (
                <TextPanel el={selectedEl} updateEl={updateEl} mode={mode} />
            )}

            {(selectedEl?.type === "rect" || selectedEl?.type === "circle") && (
                <ShapePanel el={selectedEl} updateEl={updateEl} />
            )}

            {selectedEl?.type === "image" && (
                <ImagePanel
                    el={selectedEl}
                    updateEl={updateEl}
                    mode={mode}
                    fileInputRef={fileInputRef}
                    onFileChange={onFileChange}
                    isUploadingMedia={isUploadingMedia}
                />
            )}

            {mode === "design" && (
                <>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                        Diffusion
                    </Typography>
                    <PublicationPanel
                        duration={duration}
                        setDuration={setDuration}
                        publishTo={publishTo}
                        setPublishTo={setPublishTo}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </>
            )}
        </Paper>
    );
}
